module.exports = __webpack_public_path__ + "static/media/imageIcon.009d2679.svg";